export default __webpack_public_path__ + "static/media/progressSuccessGrey.393bac86.svg";